import ContactForm from '~/components/content-modules/ContactForm.vue';
import ContentGallery from '~/components/content-modules/ContentGallery.vue';
import ContentJobList from '~/components/content-modules/ContentJobList.vue';
import ContentKeyfacts from '~/components/content-modules/ContentKeyfacts.vue';
import ContentTeam from '~/components/content-modules/ContentTeam.vue';
import ContentText from '~/components/content-modules/ContentText.vue';

export const ContentModules = {
  ContentTextRecord: ContentText,
  ContentGalleryRecord: ContentGallery,
  ContentTeamRecord: ContentTeam,
  ContactFormRecord: ContactForm,
  ContentJobListRecord: ContentJobList,
  ContentKeyfactRecord: ContentKeyfacts
};
